import { useEffect, useRef } from 'react'
import { BACKEND_BASE_URL } from '../../constants'
import { useAppDispatch } from '../../hooks'
import useNetworkStatus from '../../hooks/useNetworkStatus'
import { updateNewOrderStatus } from '../../redux-toolkits/orders/order.reducer'
import { SingleOrder } from '../../redux-toolkits/orders/orders.type'

const OrderSSEComponent = () => {
  const eventSourceRef = useRef<EventSource | null>(null)
  const audioRef = useRef<HTMLAudioElement | null>(null)
  const isOnline = useNetworkStatus()
  const dispatch = useAppDispatch()

  useEffect(() => {
    audioRef.current = new Audio('/assets/audio/notification-sound.mp3')
  }, [])

  // Manage SSE connection
  useEffect(() => {
    // Cleanup function to close any open EventSource
    const cleanup = () => {
      if (eventSourceRef.current) {
        eventSourceRef.current.close()
        eventSourceRef.current = null
      }
    }

    if (isOnline) {
      if (
        !eventSourceRef.current ||
        eventSourceRef.current.readyState === EventSource.CLOSED
      ) {
        const source = new EventSource(`${BACKEND_BASE_URL}v1/admin/order/sse`)
        eventSourceRef.current = source

        source.addEventListener('order-payment', (event) => {
          try {
            const newOrderData: SingleOrder = JSON.parse(event.data)

            if (newOrderData._id) {
              dispatch(updateNewOrderStatus(true))

              audioRef.current?.play().catch((err) => {
                console.error('Audio play error:', err)
              })
            }
          } catch (err) {
            console.error('Error parsing SSE event:', err)
          }
        })

        source.onerror = (err) => {
          console.error('SSE error:', err)
          cleanup()
        }
      }
    } else {
      // If offline, cleanup EventSource
      cleanup()
    }

    return () => {
      cleanup()
    }
  }, [isOnline, dispatch])

  return null // Component renders nothing
}

export default OrderSSEComponent
